import React from 'react';
import { Grid, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { IncidentDisplayCard } from '../../../../components/incidentCard/incidentDisplayCard.smart';
import { di } from '../../../../state/inversify.config';
import { IncidentListDomainService } from '../../../../pages/incidentsList/incidentListDomainService';

export const CreateIncident = () => {
  const { t } = useTranslation();
  const incidentListDomainService = di.get<IncidentListDomainService>(
    IncidentListDomainService,
  );
  const openIncidents = incidentListDomainService.useOrgOpenIncidentSelector();
  const user = incidentListDomainService.useUserSelector();

  return (
    <Grid item>
      {openIncidents && openIncidents?.length <= 0 && (
        <Typography sx={{ my: 1 }}>
          {t('incident.INCIDENT_LIST_YOUR_TEAMS_ARE_CLEAR')}
        </Typography>
      )}
      {openIncidents?.length === 1 && (
        <Typography sx={{ my: 1 }}>
          {t('incident.INCIDENT_LIST_YOU_HAVE_INCIDENTS_SINGULAR')}
        </Typography>
      )}
      {openIncidents?.length >= 2 && (
        <Typography sx={{ my: 1 }}>
          {t('incident.INCIDENT_LIST_YOU_HAVE_INCIDENTS_PLURAL', {
            incidentCount: openIncidents?.length,
          })}
        </Typography>
      )}
      <IncidentDisplayCard accountType={user?.accountType} />
    </Grid>
  );
};
